module.exports = __webpack_public_path__ + "img/icon-map-implantation-02.a2b17a3a.svg";